import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '../../utils/store';

export interface TRADINGState {
  current: number;
  buy_leftNav: number;
  seller_leftNav: number;
  dicker_leftNav: number;
  centerStatus: string;
}

const TRADING_KEY = 'React-ts-ant-trading';

const localTradings = LocalStore.getValue<TRADINGState>(TRADING_KEY) || {};

export const defaults: TRADINGState = {
  current: 0,
  buy_leftNav: 0,
  seller_leftNav: 0,
  dicker_leftNav: 0,
  centerStatus: '',
  ...localTradings
};

const TRADING_RECONSITUITION_KEY = 'React-ts-ant-TRADING';

export const updateTradings: (homePages: TRADINGState) => IAction<TRADINGState> = (tradings: TRADINGState) => ({
  type: TRADING_RECONSITUITION_KEY,
  payload: tradings
});

const tradingsReducer: Reducer<TRADINGState, IAction<any>> = (state = defaults, action: IAction<any>) => {
  const { type, payload } = action;

  switch (type) {
    case TRADING_RECONSITUITION_KEY:
      LocalStore.setValue(TRADING_KEY, payload as TRADINGState);
      return {
        ...payload
      };
    default:
      return {
        ...state
      };
  }
};

export default tradingsReducer;
